// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 21H2V19H22V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 16H2V14H22V16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 11H2V3H17V11Z"}}]};

const HighlightedBlockFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'highlighted-block-filled',
    ref,
    icon: element,
  },
));

HighlightedBlockFilledIcon.displayName = 'HighlightedBlockFilledIcon';

export default HighlightedBlockFilledIcon;
